import Id from '@bbx/id~master/core/ts/Id';

const id = new Id()

export interface ListenerRegister_constructor_props {
    id?: string;
    name?: string;
    callback?: (payload?: any) => void
}

export class ListenerRegister {

    id: string;
    name: string;
    callback: (payload?) => void;

    constructor(props: ListenerRegister_constructor_props = {}) {
        this.id = props.id !== undefined ? props.id : id.uniq();
        this.name = props.name !== undefined ? props.name : '';
        this.callback = props.callback !== undefined ? props.callback : () => { };
    }
}
